import { render } from "./ModalContactoGracias.vue?vue&type=template&id=7a7c23ff&scoped=true"
import script from "./ModalContactoGracias.vue?vue&type=script&lang=js"
export * from "./ModalContactoGracias.vue?vue&type=script&lang=js"

import "./ModalContactoGracias.vue?vue&type=style&index=0&id=7a7c23ff&scoped=true&lang=css"

import exportComponent from "/home/franco/Desarrollos/NC/gramosDev/Gramos/FrontEnd/trunk/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7a7c23ff"]])

export default __exports__